<template>
    <div class=''>
        <loading ref="loading"></loading>
        <b-modal centered ref="smspSearchDialog" :title="$t('translations.spine_lookup')" size="lg">

            <div>
                <!-- <div class="form-row ">
                    <div class="form-group">
                        <label for='title'>Title</label>
                        <select v-model='user_title_id' class='form-control'>
                            <option v-for="(value, key) in $root.lookup.user_titles" :value="key" :key="key">{{value}}</option>
                        </select>
                    </div>
                </div> -->

                <div class="form-row ">

                    <div class="form-group col-10">
                        <label for='dob'>{{$t('translations.DOB')}} <span class="required-field">*</span></label>
                        <vue-dob-picker v-model='dob' />
                        <inline-error v-bind:errors='errors' type='dob'></inline-error>
                    </div>

                    <div class="form-group col-10">
                        <label for='surname'>{{$t('translations.surname')}} <span class="required-field">*</span></label>
                        <input type='text' v-model='surname' class='form-control'>
                        <inline-error v-bind:errors='errors' type='surname'></inline-error>
                    </div>

                    <div class="form-group col-4">
                        <label style='white-space: nowrap' for='gender'>{{$t('translations.gender')}} <span class="required-field">*</span></label>
                        <select v-model='gender' class='form-control'>
                            <option v-for="(value, key) in this.genders" :value="key" :key="key">{{$t(value)}}</option>
                        </select>
                        <inline-error v-bind:errors='errors' type='gender'></inline-error>
                    </div>
                </div>

                <div class="form-row ">
                    <div class="form-group col-10">

                            <label for='forename'>{{$t('translations.forename')}}</label> - <span class=''>{{$t('translations.enter_only_one')}}</span>
                            <input type='text' v-model='forenames' class='form-control'>
                            <inline-error v-bind:errors='errors' type='forenames'></inline-error>

                    </div>


                    <div class="form-group col-6">
                        <label for='postcode'>{{$t('translations.postcode')}}</label>
                        <input type='text' v-model='postcode' class='form-control text-uppercase'>
                    </div>
                </div>

                <div class='alert alert-warning' v-if='result && result["user"] && result["user"]["error"]'>
                    {{result["user"]["error"]}}
                </div>

                <div v-if='result && result["user"] && result["user"]["surname"]' class=''>
                    <table style='width: 100%; border-collapse: collapse;' class='bg-light table table-xcompact table-striped'>
                        <thead>
                        <tr>
                            <th>{{$t('translations.field')}}</th>
                            <th>{{$t('translations.NHS_spine')}}</th>
                            <th>{{$t('translations.current')}}</th>
                            <th class="text-center">{{$t('translations.copy')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>{{$t('translations.NHS_number')}}</th>
                                <td>{{result["user"]["nhs_number"] | formatNhsNumber}}</td>
                                <td>{{original.nhs_number | formatNhsNumber}}</td>
                                <td class="text-center">
                                    <input 
                                        value='nhs_number' 
                                        v-if='showDiff("nhs_number")' 
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('translations.provider_code')}}</th>
                                <td>{{result["user"]["practice_code"]}}</td>
                                <td>{{original.provider ? original.provider.practice_code : ''}}</td>
                            </tr>
                            <tr>
                                <th>{{$t('translations.title')}}</th>
                                <td>{{result["user"]["title"]}}</td>
                                <td>{{$root.lookup.user_titles[original.user_title_id]}}</td>
                                <td class="text-center">
                                    <input 
                                        value='title' 
                                        v-if='showDiff("title")' 
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('translations.surname')}}</th><td>{{result["user"]["surname"]}}</td>
                                <td>{{original.surname}}</td>
                                <td class="text-center">
                                    <input 
                                        value='surname' 
                                        v-if='showDiff("surname")' 
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('translations.forenames')}}</th><td>{{result["user"]["forenames"]}}</td>
                                <td>{{original.forenames}}</td>
                                <td class="text-center">
                                    <input 
                                        value='forenames' 
                                        v-if='showDiff("forenames")' 
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('translations.date_of_birth')}}</th><td>{{result["user"]["dob"] | formatDate}}</td>
                                <td>{{original.dob | formatDate}}</td>
                                <td class="text-center">
                                    <input 
                                        value='dob' 
                                        v-if='showDiff("dob")'
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t('translations.gender')}}</th><td>{{genders[result["user"]["gender"]]}}</td>
                                <td>{{$root.lookup.genders[original.gender]}}</td>
                                <td class="text-center">
                                    <input 
                                        value='gender' 
                                        v-if='showDiff("gender")' 
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <tr v-if='result["user"]["email"] && result["user"]["email"]["USE"]'>
                                <th>{{$t('translations.email')}}</th><td>{{result["user"]["email"]["USE"]}}</td>
                                <td>{{original.email}}</td>
                                <td class="text-center">
                                    <input 
                                        value='email' 
                                        v-if='showDiff("email")' 
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <tr v-if='result["user"]["phone"] && result["user"]["phone"]["USE"]'>
                                <th>{{$t('translations.phone')}}</th><td>{{result["user"]["phone"]["USE"]}}</td>
                                <td>{{original.phone_number}}</td>
                                <td class="text-center">
                                    <input 
                                        value='phone_number' 
                                        v-if='showDiff("phone_number")' 
                                        type='checkbox' class='input' v-model='copy_items'>
                                </td>
                            </tr>
                            <template v-if='result["user"]["address"] && result["user"]["address"]["USE"]'>
                                <tr>
                                    <th>{{$t('translations.address_line_1')}}</th>
                                    <td>{{result["user"]["address"]["USE"]["address_line_0"]}}</td>
                                    <td>{{original.address_line_1}}</td>
                                    <td class="text-center">
                                        <input 
                                            value='address_line_1' 
                                            v-if='showDiff("address_line_1")' 
                                            type='checkbox' class='input' v-model='copy_items'>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('translations.address_line_2')}}</th>
                                    <td>{{result["user"]["address"]["USE"]["address_line_1"]}}</td>
                                    <td>{{original.address_line_2}}</td>
                                    <td class="text-center">
                                        <input 
                                            value='address_line_2' 
                                            v-if='showDiff("address_line_2")' 
                                            type='checkbox' class='input' v-model='copy_items'>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('translations.address_line_3')}}</th>
                                    <td>{{result["user"]["address"]["USE"]["address_line_2"]}}</td>
                                    <td>{{original.address_line_3}}</td>
                                    <td class="text-center">
                                        <input 
                                            value='address_line_3' 
                                            v-if='showDiff("address_line_3")' 
                                            type='checkbox' class='input' v-model='copy_items'>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('translations.address_line_4')}}</th>
                                    <td>{{result["user"]["address"]["USE"]["address_line_3"]}}</td>
                                    <td>{{original.address_line_4}}</td>
                                    <td class="text-center">
                                        <input 
                                            value='address_line_4' 
                                            v-if='showDiff("address_line_4")' 
                                            type='checkbox' class='input' v-model='copy_items'>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('translations.address_line_5')}}</th>
                                    <td>{{result["user"]["address"]["USE"]["address_line_4"]}}</td>
                                    <td>{{original.address_line_5}}</td>
                                    <td class="text-center">N/A</td>
                                </tr>
                                <tr>
                                    <th>{{$t('translations.postcode')}}</th>
                                    <td>{{result["user"]["address"]["USE"]["postcode"]}}</td>
                                    <td>{{original.postcode}}</td>
                                    <td class="text-center">
                                        <input 
                                            value='postcode' 
                                            v-if='showDiff("postcode")' 
                                            type='checkbox' class='input' v-model='copy_items'>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>

            </div>
            <!-- <img :width='full_image.width' :height='full_image.height' style='max-width: 100%; max-height: 100%;' :src='full_image.data'> -->
            <div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-left" variant="primary" v-on:click.prevent='$refs.smspSearchDialog.hide()'>
                    {{$t('translations.close')}}
                </b-btn>
                <b-btn size="sm" class="float-left ml-1" variant="primary" v-on:click.prevent='clear'>
                    {{$t('translations.clear')}}
                </b-btn>

                <b-btn size="sm" class="float-right btn-success" variant="primary" v-on:click.prevent='searchSmsp'>
                    {{$t('translations.search')}}
                </b-btn>
                 <b-btn v-if='result && result["user"] && result["user"]["surname"]' size="sm" class="float-right mr-1 btn-success" variant="primary" v-on:click.prevent='copyToPatientRecord'>
                    {{autobrand('translations.copy_to_patient_record')}}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: {
		},
		data: function(){
			return {
                user: {},
                forenames: "",
                surname: "",
                gender: "",
                dob: "",
                postcode: "",
                user_title_id: "",
                result: null,
                genders: {1: "Male", 2: "Female"},
                errors: [],
                original: {},
                diff_items: [],
                copy_items: [],
			};
		},
		computed: {

		},
		mounted() {
            console.log(this.user);

        },
        watch: {

        },
		methods: {
            showSmspSearchDialog(user) {
                this.user = user;
                this.$refs.smspSearchDialog.show();
                Vue.nextTick(() => {
                    this.dob = user.dob;
                    this.original = user;
                    this.surname = user.surname;
                    //this.dob = user.dob;
                    switch(user.gender) {
                        case 'm': this.gender = '1'; break;
                        case 'f': this.gender = '2'; break;
                        default: this.gender = ''; break;
                    }
                    var forename_parts = user.forenames.match(/^[^ ]*/);
                    this.forenames = forename_parts[0];
                    this.postcode = user.postcode;
                    this.errors = [];
                    this.result = null;

                    // !!!!TESTING
                    // this.surname = 'Shipperbottom';
                    // this.forenames = '';
                    // this.gender = 2;
                    // this.postcode = '';
                    // this.dob = '2011-05-09';
                })
            },
            // Added this so we have a generic set of comparison operators, but actually only using lower case for now.
            different(item1, item2, item1_blank_is_different = false) {
                if(item1 && !item2) {
                    return true;
                }
                // If item1 is not set, we only treat them as different if we are told to. Used for 
                // addresses where either none of the lines are set (no differences), or some of them are set
                // all of them are different.
                if(!item1 && item2) {
                    return item1_blank_is_different;
                }
                if(!item1 && !item2) {
                    return false;
                }
                return item1.toString().toLowerCase().replaceAll(" ", "") != item2.toString().toLowerCase().replaceAll(" ", "");
            },
            showDiff(item) {
                return this.diff_items.indexOf(item) != -1;
            },
            searchSmsp() {
                this.$root.setLoading(true);

                this.errors = [];
                this.result = null;
                this.copy_items = [];
                this.diff_items = [];

                //19420114/1/MITTON/Thomas/DN171PS
                axios.get('/api/v1/smsp', {params: {dob: this.dob, gender: this.gender, surname: this.surname, forenames: this.forenames, postcode: this.postcode}}).then((res) => {
	                this.$root.setLoading(false);
                    this.result = res.data;
                    if(!this.result["user"]["error"]) {
                        this.result["user"]["address"]["USE"] = this.get_communication(this.result["user"]["address"]);
                        if(this.result["user"]["phone"]) {
                            this.result["user"]["phone"]["USE"] = this.get_communication(this.result["user"]["phone"]);
                        }
                        if(this.result["user"]["email"]) {
                            this.result["user"]["email"]["USE"] = this.get_communication(this.result["user"]["email"]);
                        }
                        if(this.result.user.address && this.result.user.address.USE) {
                            // Testing blank addresses
                            //this.result.user.address.USE.address_line_0 = this.result.user.address.USE.address_line_1 = this.result.user.address.USE.address_line_2 = this.result.user.address.USE.address_line_3 = "";
                            var have_address = this.result.user.address.USE.address_line_0 || this.result.user.address.USE.address_line_1 || this.result.user.address.USE.address_line_2 || this.result.user.address.USE.address_line_3;
                            if(this.different(this.result.user.address.USE.address_line_0, this.user.address_line_1, have_address)) {
                                this.diff_items.push("address_line_1");
                            }
                            if(this.different(this.result.user.address.USE.address_line_1, this.user.address_line_2, have_address)) {
                                this.diff_items.push("address_line_2");
                            }
                            if(this.different(this.result.user.address.USE.address_line_2, this.user.address_line_3, have_address)) {
                                this.diff_items.push("address_line_3");
                            }
                            if(this.different(this.result.user.address.USE.address_line_3, this.user.address_line_4, have_address)) {
                                this.diff_items.push("address_line_4");
                            }
                            // We don't have space in our address for this
                            
                            // if(this.results.address.USE.address_line_4 != this.user.address_line_5) {
                            //     this.diff_items.push("address_line_5");
                            // }

                            if(this.different(this.result.user.address.USE.postcode, this.user.postcode)) {
                                this.diff_items.push("postcode");
                            }
                            
                        }
                        if(this.result.user.phone && this.result.user.phone.USE) {
                            if(this.different(this.result.user.phone.USE, this.user.phone_number)) {
                                this.diff_items.push("phone_number");
                            }
                        }
                        if(this.result.user.email && this.result.user.email.USE) {
                            if(this.different(this.result.user.email.USE, this.user.email)) {
                                this.diff_items.push("email");
                            }
                        }

                        if(this.different(this.result.user.forenames, this.user.forenames)) {
                            this.diff_items.push("forenames");
                        }
                        
                        if(this.different(this.result.user.surname, this.user.surname)) {
                            this.diff_items.push("surname");
                        }
                        
                        if(this.different(this.result.user.dob, this.user.dob)) {
                            this.diff_items.push("dob");
                        }

                        var convGender;
                        switch(this.user.gender) {
                            case 'm': convGender = '1'; break;
                            case 'f': convGender = '2'; break;
                            default: convGender = ''; break;
                        }
                        if(this.different(this.result.user.gender, convGender)) {
                            this.diff_items.push("gender");
                        }

                        if(this.different(this.result.user.nhs_number, this.user.nhs_number)) {
                            this.diff_items.push("nhs_number");
                        }

                        if(this.different(this.result.user.title, this.$root.lookup.user_titles[this.user.user_title_id])) {
                            this.diff_items.push("title");
                        }

                        this.diff_items.forEach(item => {this.copy_items.push(item)});
                        console.log("DIFF", this.diff_items);
                        console.log("COPY", this.copy_items);
                    }
                    
                    
	            }).catch((error) => {
	                this.$root.setLoading(false);
	                this.handleError(error, "spine search");
	            });
            },
            copyToPatientRecord() {
                if(this.copy_items.indexOf("email") != -1 && this.user.email) {
                    this.$modal.show('dialog', {
                    title: 'New Email Address',
                    text: "The email address in the spine lookup is not the same as the email in the system. The email address is used by the patient to log in to " + this.tBrand('app_name') + ", so overwriting it could potentially prevent the user from accessing " + this.tBrand('app_name') + ". Do you want to continue and overwrite the email address?",
                    buttons: [
                    {
                        title: 'Yes',
                        handler: () => {
                            this.$modal.hide('dialog');
                            this.$emit('copy', {"result": this.result, "copy_items": this.copy_items});
                            this.$refs.smspSearchDialog.hide();
                        },
                    },
                    {
                        title: 'Cancel',
                        default: true
                    }]});
                }
                else {
                    this.$emit('copy', {"result": this.result, "copy_items": this.copy_items});
                    this.$refs.smspSearchDialog.hide();
                }
            },
            clear() {
                this.surname =
                this.dob =
                this.gender =
                this.forenames =
                this.postcode = "";
                this.errors = [];
                this.result = null;
            },
            get_communication($comms) {
                if($comms) {
                    if($comms.HP) {
                        return $comms.HP;
                    }
                    else if($comms.MC) {
                        return $comms.MC;
                    }
                    else if($comms.H) {
                        return $comms.H;
                    }
                    else if($comms.HV) {
                        return null;
                    }
                    else if($comms.WP) {
                        return null;
                    }
                    else if($comms.AS) {
                        return null;
                    }
                    else if($comms.EC) {
                        return null;
                    }
                    else if($comms.PG) {
                        return null;
                    }
                    else if($comms.ZZ) {
                        return $comms.ZZ;
                    }
                }
                return null;
            }
		}
    }
</script>
